interface Props {
  id: string;
  label: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  error?: string;
  emptyMessage?: string;
  invalidMessage?: string;
}

function CustomToggle({
  id,
  label,
  checked,
  onChange,
  name,
  error,
  emptyMessage,
  invalidMessage,
}: Props) {
  return (
    <>
      <label className="toggle" htmlFor={id}>
        <input type="checkbox" name={name} checked={checked} id={id} onChange={onChange} />
        <span className="input-label">{label}</span>
        <span className="toggle__checkmark" />
      </label>
      {!error ? null : (
        <div className="input-error">
          <span>
            {error === 'empty' ? emptyMessage : error === 'invalid' ? invalidMessage : ''}
          </span>
        </div>
      )}
    </>
  );
}

export default CustomToggle;
